// src/components/circles/FriendCirclesRouter.jsx
// Smart router that directs users to the right Friend Circles page based on their state
import { useEffect, useState } from 'react';
import { useCirclesStore } from '../../stores/circlesStore';
import { usePrivacyAuth } from '../../context/PrivacyAuthContext';
import { useApp } from '../../context/AppContext';
import FriendCirclesLanding from '../../pages/FriendCirclesLanding';

export default function FriendCirclesRouter() {
  const { user } = usePrivacyAuth();
  const { myCircles, loadMyCircles, activeCircleId, setActiveCircle } = useCirclesStore();
  const { setCurrentView } = useApp();
  const [isChecking, setIsChecking] = useState(true);
  const [shouldShowLanding, setShouldShowLanding] = useState(false);

  useEffect(() => {
    const checkAndRoute = async () => {
      console.log('🔄 FriendCirclesRouter: Checking user state...', { user: user?.userId });

      // Not logged in → Show Landing page
      if (!user) {
        console.log('🔄 FriendCirclesRouter: No user, showing landing');
        setShouldShowLanding(true);
        setIsChecking(false);
        return;
      }

      // Logged in → Check for circles
      const userId = user.userId;
      console.log('🔄 FriendCirclesRouter: Loading circles for user:', userId);
      await loadMyCircles(userId);

      // Wait for store to update and get fresh state
      const circles = useCirclesStore.getState().myCircles;
      const currentActiveId = useCirclesStore.getState().activeCircleId;
      console.log('🔄 FriendCirclesRouter: Circles loaded:', circles?.length);
      console.log('🔄 FriendCirclesRouter: Current active circle:', currentActiveId);

      if (circles && circles.length > 0) {
        // Has circles → Set active circle if not set, then go to dashboard
        if (!currentActiveId) {
          console.log('🔄 FriendCirclesRouter: Setting first circle as active:', circles[0].id);
          setActiveCircle(circles[0].id);
        }
        console.log('🔄 FriendCirclesRouter: User has circles, navigating to dashboard');
        setCurrentView('circle-dashboard');
      } else {
        // No circles → Show welcome/setup
        console.log('🔄 FriendCirclesRouter: No circles, navigating to welcome');
        setCurrentView('friend-circles-welcome');
      }
      setIsChecking(false);
    };

    checkAndRoute();
  }, [user, loadMyCircles, setCurrentView, setActiveCircle]);

  if (isChecking) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-purple-500/30 border-t-purple-500 rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-purple-300">Loading your circles...</p>
        </div>
      </div>
    );
  }

  // If not logged in, render the landing page
  if (shouldShowLanding) {
    return <FriendCirclesLanding />;
  }

  return null;
}
